module.exports = __webpack_public_path__ + "img/map_14.fea81100.png";